import {Context} from '../../../../Helpers/Auth';
import SelectComponent from '../../../Selects/SelectComponent';
import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DirectionsRoundedIcon from '@mui/icons-material/DirectionsRounded';

import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {v4 as uuidv4} from 'uuid';
import {useEffect} from 'react';
import {getLatituraLongiturFromPostalCode} from '../../../../pages/requests';

function Endereço({info}) {
    const {t} = useTranslation();
    const history = useHistory();
    const {
        prospect,

        editarProspect,
        paises,

        linhasEnderecos,
        setLinhasEnderecos,

        setValidacaoPais,
        validacaoPais,
        validacaoCP,
        setValidacaoCP,

        setOnChangeForm,
        openTab,
    } = info;

    // Encdereços
    const [prospectMoradaID, setProspectMoradaID] = useState('');
    const [prospectMoradaPais, setProspectMoradaPais] = useState(null);
    const [prospectMoradaMorada, setProspectMoradaMorada] = useState('');
    const [prospectMoradaCodigoPostal, setProspectMoradaCodigoPostal] = useState('');
    const [prospectMoradaCidade, setProspectMoradaCidade] = useState('');
    const [prospectMoradaContacto, setProspectMoradaContacto] = useState('');
    const [prospectMoradaEmail, setProspectMoradaEmail] = useState('');
    const [prospectMoradaDescricao, setProspectMoradaDescricao] = useState('');
    const [prospectMoradaLatitude, setProspectMoradaLatitude] = useState('');
    const [prospectMoradaLongitude, setProspectMoradaLongitude] = useState('');

    const [prospectMoradaEnderecoDefeito, setProspectMoradaEnderecoDefeito] = useState(false);

    async function limparCampos() {
        setProspectMoradaID('');
        setProspectMoradaPais(null);
        setProspectMoradaMorada('');
        setProspectMoradaCodigoPostal('');
        setProspectMoradaCidade('');
        setProspectMoradaContacto('');
        setProspectMoradaEmail('');
        setProspectMoradaDescricao('');
        setProspectMoradaLatitude('');
        setProspectMoradaLongitude('');
        setProspectMoradaEnderecoDefeito('');
    }

    function EditarLinhaEnderecos(linha) {
        setProspectMoradaID(linha.id);
        setProspectMoradaPais(linha.pais);
        setProspectMoradaMorada(linha.morada);
        setProspectMoradaCodigoPostal(linha.codigoPostal);
        setProspectMoradaCidade(linha.cidade);
        setProspectMoradaContacto(linha.contacto);
        setProspectMoradaEmail(linha.email);
        setProspectMoradaDescricao(linha.descricao);
        setProspectMoradaLatitude(linha.latitude);
        setProspectMoradaLongitude(linha.longitude);
        setProspectMoradaEnderecoDefeito(linha.enderecoDefeito);
    }

    function atualizaEnderecoR(codigo, pais, morada, codPostal, cidade, enderecoDefeito, descricao, id) {
        if (id != '' && id != undefined) {
            var comps = [];
            linhasEnderecos.forEach(element => {
                if (element.id == id) {
                    const enderecoAtualizado = {
                        id: id,
                        pais: pais,
                        morada: morada,
                        codigoPostal: codPostal,
                        cidade: cidade,
                        enderecoDefeito: enderecoDefeito,
                        descricao: descricao,
                    };
                    comps.push(enderecoAtualizado);
                } else {
                    comps.push(element);
                }
            });
            setLinhasEnderecos(comps);
        }
    }

    useEffect(() => {
        // if (openTab != 2) {
        //    alert("oi")
        // }
    }, [openTab]);

    function verificarEnderecoDefeito(e) {
        const algumEnderecoDefeito = linhasEnderecos.some(objeto => objeto.enderecoDefeito);
        const todosEnderecoDefeitoFalse = linhasEnderecos.every(objeto => !objeto.enderecoDefeito);

        if (e && todosEnderecoDefeitoFalse) {
            const novasLinhasEnderecos = [...linhasEnderecos];
            novasLinhasEnderecos[0].enderecoDefeito = true;
            setLinhasEnderecos(novasLinhasEnderecos);
        }
    }


    useEffect(() => {
        const todosEnderecoDefeitoFalse = linhasEnderecos.every(objeto => !objeto.enderecoDefeito);

        if (todosEnderecoDefeitoFalse && linhasEnderecos.length > 0) {
            const novasLinhasEnderecos = [...linhasEnderecos];
            novasLinhasEnderecos[0].enderecoDefeito = true;
            setLinhasEnderecos(novasLinhasEnderecos);
        }
    }, [linhasEnderecos]);

    function adicionarLinhaEnderecos() {
        debugger;
        //validar se pais e CP estão preenchidos
        if (!prospectMoradaPais || prospectMoradaCodigoPostal == '') {
            setValidacaoCP(true);
            setValidacaoPais(true);
            toast.warn(t('preenchaCamposLinhaE'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        // Verificar se o CP apenas contem digitos
        // const verificacaoLetras = /^[^a-zA-Z]*$/.test(
        //     prospectMoradaCodigoPostal,
        // );
        // const verificacaoCarateres =
        //     /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
        //         prospectMoradaCodigoPostal,
        //     );
        // if (!verificacaoLetras || verificacaoCarateres) {
        if (!RegExp(prospectMoradaPais.formato).test(prospectMoradaCodigoPostal)) {
            setValidacaoCP(true);
            toast.warn(t('validacaoCP'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        // guarda a linha de endereço
        let x = linhasEnderecos
            .filter(e => e.id[0] == 'E')
            .map(e => Number(e.id.slice(1)))
            .sort()
            .reverse()[0];
        if (x == NaN || x == undefined) {
            x = 0;
        }

        if (linhasEnderecos.length == 1) {
            setProspectMoradaEnderecoDefeito(true);
        }

        setLinhasEnderecos([
            // outras moradas
            ...linhasEnderecos
                .filter(element => element.id != '')
                .map(m => {
                    return {
                        ...m,
                        enderecoDefeito: prospectMoradaEnderecoDefeito ? false : m.enderecoDefeito,
                    };
                }),

            // novo endereço
            {
                id: 'E' + String(x + 1).padStart(3, '0'),
                pais: prospectMoradaPais,
                morada: prospectMoradaMorada,
                codigoPostal: prospectMoradaCodigoPostal,
                cidade: prospectMoradaCidade,
                enderecoDefeito: linhasEnderecos.length == 1 ? true : prospectMoradaEnderecoDefeito,
                descricao: prospectMoradaDescricao,
                latitude: prospectMoradaLatitude,
                longitude: prospectMoradaLongitude,
            },
            // linha Vazia
            {
                id: '',
                pais: null,
                morada: '',
                codigoPostal: '',
                cidade: '',
                enderecoDefeito: false,
                descricao: '',
                latitude: '',
                longitude: '',
            },
        ]);

        // limpar campos do fomulario
        limparCampos();
    }

    function EliminarLinhaEnderecos(linha) {
        setLinhasEnderecos(
            linhasEnderecos
                .filter(m => m.id !== linha.id || m.id === '')
                .map((m, i, a) => {
                    return {
                        ...m,
                        enderecoDefeito: i == 0 && !a.find(mm => mm.enderecoDefeito) ? true : m.enderecoDefeito,
                    };
                }),
        );

        limparCampos();
    }

    function atualizaMoradas() {
        if (prospectMoradaID !== '') {
            setLinhasEnderecos(
                linhasEnderecos.map(m =>
                    m.id !== prospectMoradaID
                        ? {
                              ...m,
                              enderecoDefeito: prospectMoradaEnderecoDefeito ? false : m.enderecoDefeito,
                          }
                        : {
                              id: prospectMoradaID,
                              pais: prospectMoradaPais,
                              morada: prospectMoradaMorada,
                              codigoPostal: prospectMoradaCodigoPostal,
                              cidade: prospectMoradaCidade,
                              descricao: prospectMoradaDescricao,
                              latitude: prospectMoradaLatitude,
                              longitude: prospectMoradaLongitude,
                              enderecoDefeito: prospectMoradaEnderecoDefeito,
                          },
                ),
            );
        }
    }

    useEffect(() => {
        if (prospectMoradaID !== '') {
            atualizaMoradas();
        }
    }, [
        prospectMoradaID,
        prospectMoradaPais,
        prospectMoradaMorada,
        prospectMoradaCodigoPostal,
        prospectMoradaCidade,
        prospectMoradaDescricao,
        prospectMoradaLatitude,
        prospectMoradaLongitude,
        prospectMoradaEnderecoDefeito,
    ]);

    useEffect(() => {
        if (prospectMoradaPais?.value === 'PT' && new RegExp(/\d{4}(-)?\d{3}/).test(prospectMoradaCodigoPostal)) {
            getLatituraLongiturFromPostalCode(prospectMoradaCodigoPostal).then(res => {
                if (!prospectMoradaCidade) setProspectMoradaCidade(res.data.Localidade);
                if (!prospectMoradaLatitude) setProspectMoradaLatitude(res.data.centro[0] + '');
                if (!prospectMoradaLongitude) setProspectMoradaLongitude(res.data.centro[1] + '');
            });
        }
    }, [prospectMoradaCodigoPostal, prospectMoradaPais]);

    function openGoogleMaps(dados) {
        debugger;
        const url = `https://www.google.com/maps/dir/?api=1&destination=${dados.latitude},${dados.longitude}`;
        window.open(url, '_blank');
    }
    return (
        <>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full  text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-2 py-3">
                                    {t('codigoEndereco')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('pais')}
                                </th>
                                <th scope="col" className=" py-3">
                                    {t('descricao')}
                                </th>
                                <th scope="col" className=" py-3"></th>
                                <th scope="col" className=" py-3"></th>
                            </tr>
                        </thead>

                        <tbody>
                            {linhasEnderecos.map(dados => (
                                <tr
                                    className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                    onClick={() => {
                                        EditarLinhaEnderecos(dados);
                                    }}>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.id}
                                    </th>
                                    <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.pais?.label ?? ''}
                                    </th>

                                    <td className="px-2 py-1">
                                        <div className="flex flex-row items-center justify-between ">
                                            {dados.descricao ? dados.descricao : '-'}{' '}
                                            <div className="flex flex-row items-center">
                                                <button
                                                    disabled={!editarProspect}
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        EliminarLinhaEnderecos(dados);
                                                    }}
                                                    className={` ml-2 hover:text-red-800 text-red-600 hover:dark:text-red-700 py-1 ${!editarProspect ? 'disabled' : ''}`}>
                                                    <DeleteForeverIcon />
                                                </button>
                                                <div
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        EditarLinhaEnderecos(dados);
                                                    }}
                                                    className="ml-2 hover:text-blue-800 text-green-600 hover:dark:text-green-600 py-1">
                                                    <SearchRoundedIcon />
                                                </div>
                                                <div
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        openGoogleMaps(dados);
                                                    }}
                                                    title={t('rotas')}
                                                    className="ml-2 hover:text-blue-800 text-blue-600 hover:dark:text-blue-600 py-1">
                                                    <DirectionsRoundedIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="grid gap-6 mb-3 md:grid-cols-2">
                    <div>
                        <label htmlFor="paises" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('pais')}*
                        </label>
                        <SelectComponent
                            isDisabled={!editarProspect}
                            options={paises}
                            value={prospectMoradaPais}
                            onChange={e => {
                                setValidacaoPais(false);
                                setProspectMoradaPais(e);
                                setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                        {validacaoPais ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                    </div>
                    <div>
                        <label htmlFor="endereco" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('endereco')}
                        </label>
                        <input
                            type="text"
                            id="endereco"
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                            }`}
                            value={prospectMoradaMorada}
                            maxLength={50}
                            required
                            onChange={e => {
                                setOnChangeForm(true);
                                setProspectMoradaMorada(e.target.value);
                            }}
                            disabled={!editarProspect}
                        />
                    </div>
                    <div>
                        <label htmlFor="codigoPostal" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('codigoPostal')}*
                        </label>
                        <input
                            type="text"
                            pattern={prospectMoradaPais?.formato}
                            id="codigoPostal"
                            //maxLength={7}
                            className={`border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                validacaoCP ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                            }${editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'}`}
                            placeholder="ex: 4900-123"
                            required
                            value={prospectMoradaCodigoPostal}
                            onChange={e => {
                                setProspectMoradaCodigoPostal(e.target.value);
                                setOnChangeForm(true);
                                setValidacaoCP(false);
                            }}
                            disabled={!editarProspect}
                        />
                    </div>
                    <div>
                        <label htmlFor="cidade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('cidade')}
                        </label>
                        <input
                            type="tel"
                            id="cidade"
                            value={prospectMoradaCidade}
                            maxLength={40}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                            }`}
                            required
                            disabled={!editarProspect}
                            onChange={e => {
                                setOnChangeForm(true);
                                setProspectMoradaCidade(e.target.value);
                            }}
                        />
                    </div>
                    <div className=" col-span-2 mb-3">
                        <label htmlFor="descricao" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('descricao')}
                        </label>
                        <textarea
                            disabled={!editarProspect}
                            id="descricao"
                            rows="1"
                            maxLength={250}
                            value={prospectMoradaDescricao}
                            onChange={e => {
                                setOnChangeForm(true);
                                setProspectMoradaDescricao(e.target.value);
                            }}
                            className={`block p-2.5 w-full text-sm text-gray-900 rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                            } `}
                            placeholder={t('escrevaDescricao')}></textarea>
                    </div>

                    <div>
                        <label htmlFor="latitude" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('latitude')}
                        </label>
                        <input
                            type="tel"
                            id="latitude"
                            value={prospectMoradaLatitude}
                            maxLength={40}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                            }`}
                            required
                            disabled={!editarProspect}
                            onChange={e => {
                                setOnChangeForm(true);
                                setProspectMoradaLatitude(e.target.value);
                            }}
                        />
                    </div>
                    <div>
                        <label htmlFor="longitude" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('longitude')}
                        </label>
                        <input
                            type="tel"
                            id="longitude"
                            value={prospectMoradaLongitude}
                            maxLength={40}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                            }`}
                            required
                            disabled={!editarProspect}
                            onChange={e => {
                                setOnChangeForm(true);
                                setProspectMoradaLongitude(e.target.value);
                            }}
                        />
                    </div>

                    <div className="flex items-center mb-4">
                        <input
                            onChange={e => {
                                setProspectMoradaEnderecoDefeito(e.target.checked);
                                setOnChangeForm(true);
                                verificarEnderecoDefeito(e.target.checked);
                            }}
                            id="default-checkbox"
                            type="checkbox"
                            value=""
                            checked={prospectMoradaEnderecoDefeito}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label htmlFor="default-checkbox" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            {t('enderecoDefeito')}
                        </label>
                    </div>
                    {!prospectMoradaID && (
                        <div className="flex flex-row justify-end">
                            <button
                                id="adicionarLinha"
                                type="button"
                                onClick={() => {
                                    adicionarLinhaEnderecos();
                                }}
                                className=" flex items-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                {t('registarMorada')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default Endereço;
